export class Recurring {

  constructor() {
    this.tax_rate = 21;
  }

  id!: string;
  customer!: string;
  interval!: string; // cron
  type!: string;
  name!: string;
  description!: string;
  amount!: number;
  price!: number;
  uom!: string;
  tax_rate!: number;

}
